<ng-container *ngIf="company === 'Guidewire'; else otherCompany">
    <div class="bn-make-a-payment">
        <ng-container *ngIf="!hideMethodOptions">
            <app-bn-make-a-payment-landing [policy]="policy" (checkingOrSavings)="onCheckingOrSavingsAccount()"></app-bn-make-a-payment-landing>
        </ng-container>
        <ng-container *ngIf="showCheckingOrSavingPayment">
            <app-bn-make-checking-savings-payment [policy]="policy" (showLandingPageEvent)="showLandingPage()"></app-bn-make-checking-savings-payment>
        </ng-container>
    </div>
</ng-container>
<ng-template #otherCompany>
    <div class="bn-notice-content" *ngIf="policy?.policyStatus === 'CANCELLED'">
        <app-bn-imp-notice [policy]="policy"></app-bn-imp-notice>
    </div>
    <app-bn-makepayment-other-policies [policy]="policy"></app-bn-makepayment-other-policies>
</ng-template>
